module.exports = __webpack_public_path__ + "bc6ba5af94ac3e47a38d311869e32d5e.png";